export const permission = {
  MYMEDAX_QUESTIONNAIRE_SUBMISSION_READ: 'MYMEDAX_QUESTIONNAIRE_SUBMISSION_READ'
};
